import React from 'react'

import i18n from 'i18n-literally'

import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Box } from '@mui/material'

import createLogger from '~/src/Lib/Logging'
import { SuccessGateway } from '~/src/UI/Icons/SuccessGateway'
import Button from '~/src/UI/Shared/Button'
import T from '~/src/UI/Shared/Typography'

import { PUBLIC_ROUTES, REGISTER_ROUTES } from '../constants'

const displayName = 'SuccessGateway'
const logger = createLogger(displayName)

const GatewaySuccess = () => (
  <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap="2rem">
    <CheckCircleIcon sx={{ width: 50, height: 50 }} color="success" />
    <SuccessGateway />
    <T.H2>{i18n`Success!`}</T.H2>
    <Box maxWidth={550} textAlign="center" display="flex" flexDirection="column">
      <T>{i18n`We found your new Gateway H123445566.`}</T>
      <T>{i18n`Now you can continue to create a new AROYA organization account with new credentials.`}</T>
    </Box>
    <Button href={REGISTER_ROUTES.NEW_ACCOUNT}>{i18n`Create New AROYA GO Account`}</Button>
    <T maxWidth={500} textAlign="center">
      {i18n`Do you already use AROYA and want to add this AROYA GO using the same login?  Continue with your existing info.`}
    </T>
    <Button href={PUBLIC_ROUTES.LOGIN} variant="outlined">{i18n`Login Aroya`}</Button>
  </Box>
)

const Memoized = React.memo(GatewaySuccess)
export default Memoized
